import { render, staticRenderFns } from "./CustomizeReport.vue?vue&type=template&id=4c485037&scoped=true"
import script from "./CustomizeReport.vue?vue&type=script&lang=js"
export * from "./CustomizeReport.vue?vue&type=script&lang=js"
import style0 from "./CustomizeReport.vue?vue&type=style&index=0&id=4c485037&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c485037",
  null
  
)

export default component.exports